import { faCamera, faCode, faCogs, faMicrophone, faVideo } from '@fortawesome/free-solid-svg-icons';
import { faWordpress } from '@fortawesome/free-brands-svg-icons';


const ServiceData = [
    {
      id: 1, name:'WEB', title: 'DESIGN & DEVELOPMENT', icon:faCode, details:
        'We will convert your PSD to HTML & also we can create an HTML Email Template.',
    },
    {
        id: 2, name:'WORDPRESS', title: 'THEME DEVELOPMENT', icon:faWordpress, details:
          'We can help you to make awesome website for your buisiness.',
      },
      {
        id: 3, name:'LEAD', title: 'GENERATION', icon:faVideo, details:
          'We can provide all kinds of lead generation services within the deadline and at affordable prices.',
      },
      {
        id: 4, name:'GRAPHIC', title: 'DESIGN', icon:faMicrophone, details:
          'We will make a clean, unique, and professional-looking design.',
      },
      {
        id: 5, name:'E-COMMERCE', title: 'SOLUTION', icon:faCogs, details:
          'Do you want to sell your product online? We will build your online eCommerce website with very professional looking',
      },
      {
        id: 6, name:'PAGE', title: 'SPEED OPTIMIZATION', icon:faCamera, details:
          'We will convert your PSD to HTML & also we can create an HTML Email Template.',
      },
    
  ];

export default ServiceData;